/**
 * av-variant-selector.js
 * Opens the theme's existing Quick Shop modal for each selected Ascari.
 * It also controls the reference-style sticky purchase bar. The modal owns
 * variant selection and its own add-to-cart flow, so this section never adds
 * an assumed variant directly to the cart.
 */
(function () {
  var initialized = new WeakSet();
  var cleanups = new WeakMap();

  function waitForQuickShopContent(button) {
    var productId = button.dataset.productId;
    var handle = button.dataset.productHandle;
    var holder = document.getElementById('QuickShopHolder-' + handle);

    if (!productId || !handle || !holder || !window.theme || typeof window.theme.preloadProductModal !== 'function') {
      return;
    }

    if (holder.querySelector('.product-section')) return;
    if (button.dataset.avQuickShopBusy === 'true') return;

    button.dataset.avQuickShopBusy = 'true';
    button.classList.add('quick-product__btn--not-ready');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    // The live theme fetches /products/{handle}?view=modal, injects the
    // product section, creates theme.Modals, and then removes its not-ready
    // marker. A second click opens the now-initialized modal listener.
    window.theme.preloadProductModal(handle, productId, button);

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (holder.querySelector('.product-section')) {
        window.clearInterval(timer);
        button.dataset.avQuickShopBusy = 'false';
        button.classList.remove('quick-product__btn--not-ready');
        button.removeAttribute('aria-busy');
        button.disabled = false;
        button.click();
      } else if (attempts >= 100) {
        window.clearInterval(timer);
        button.dataset.avQuickShopBusy = 'false';
        button.classList.remove('quick-product__btn--not-ready');
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }, 50);
  }

  function initSection(section) {
    if (!section || initialized.has(section)) return;
    initialized.add(section);

    section.querySelectorAll('[data-av-quick-shop]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        var holder = document.getElementById('QuickShopHolder-' + button.dataset.productHandle);
        // Once the product section is loaded, the theme's own modal listener
        // handles this click. Before that, preload it and replay the click.
        if (holder && holder.querySelector('.product-section')) return;
        event.preventDefault();
        waitForQuickShopContent(button);
      });
    });

    var ticking = false;
    function updateStickyBar() {
      ticking = false;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var sectionRect = section.getBoundingClientRect();
      // Keep the bar scoped to this section: show after its top reaches the
      // upper quarter, then hide as soon as its bottom leaves the viewport.
      var show = viewportHeight > 0 && sectionRect.top < viewportHeight * 0.25 && sectionRect.bottom > 0;
      section.classList.toggle('is-sticky-visible', show);
    }

    function requestStickyUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateStickyBar);
    }

    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
    updateStickyBar();

    cleanups.set(section, function () {
      window.removeEventListener('scroll', requestStickyUpdate);
      window.removeEventListener('resize', requestStickyUpdate);
      initialized.delete(section);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.av-variant').forEach(initSection);
  }

  function teardown(scope) {
    (scope || document).querySelectorAll('.av-variant').forEach(function (section) {
      var cleanup = cleanups.get(section);
      if (cleanup) cleanup();
      cleanups.delete(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    teardown(event.target);
  });
})();
